import md5 from "crypto-js/md5"

export function detectPlatform(userAgent) {
  const ua = userAgent?.toLowerCase() || (typeof window !== "undefined" ? navigator.userAgent.toLowerCase() : "")

  if (!ua) return "widevine"

  if (ua.includes("iphone") || ua.includes("ipad")) {
    return "fairplay"
  }

  if (ua.includes("safari") && !ua.includes("chrome") && !ua.includes("chromium")) {
    return "fairplay"
  }

  return "widevine"
}

export function getSessionSign(sessionId, secretKey) {
  const sign = md5(sessionId + secretKey).toString()
  return sign
}

export const getDeviceBrand = () => {
  if (typeof window === "undefined") return "Windows"
  const ua = navigator.userAgent
  if (ua.includes("Mac")) return "Mac"
  if (ua.includes("Linux")) return "Linux"
  return "Windows"
}

export function maskPhoneNumber(name) {
  if (/^\d{9,}$/.test(name)) {
    return name.slice(0, -3) + "xxx"
  }
  return name
}
